module.exports = __webpack_public_path__ + "media/public/images/logo-conecta-recife-4d503bb89e8817ab3649050dd118f105.svg";